import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取活动列表
export const getFeiyongList = params => {
    return get("/admin/recharage/page", params);
};
// 编辑
export const editFeiyong = params => {
    return post("/admin/recharage/updateBalance", params);
};


// WEBPACK FOOTER //
// ./src/api/feiyong.js